import { render, staticRenderFns } from "./JcdcErrorAccessDenied.vue?vue&type=template&id=3f93a1ba&scoped=true"
import script from "./JcdcErrorAccessDenied.vue?vue&type=script&lang=ts"
export * from "./JcdcErrorAccessDenied.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f93a1ba",
  null
  
)

export default component.exports